import * as React from 'react';
import { IgcFileInputComponent as Component } from 'igniteui-webcomponents';
import type { IgcFileInputComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * @slot prefix - Renders content before the input.
 * @slot suffix - Renders content after input.
 * @slot helper-text - Renders content below the input.
 * @slot file-selector-text - Renders content for the browse button when input type is file.
 * @slot file-missing-text - Renders content when input type is file and no file is chosen.
 * @slot value-missing - Renders content when the required validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcChange - Emitted when the control's checked state changes.
 * @fires igcCancel - Emitted when the control's file picker dialog is canceled.
 * @csspart container - The main wrapper that holds all main input elements.
 * @csspart input - The native input element.
 * @csspart label - The native label element.
 * @csspart file-names - The file names wrapper when input type is 'file'.
 * @csspart file-selector-button - The browse button when input type is 'file'.
 * @csspart prefix - The prefix wrapper.
 * @csspart suffix - The suffix wrapper.
 * @csspart helper-text - The helper text wrapper.
 * @class
 */
export const IgrFileInput = /* @__PURE__ */ createComponent({
  tagName: 'igc-file-input',
  displayName: 'IgrFileInput',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<
      IgcFileInputComponentEventMap['igcChange']
    >,
    onCancel: 'igcCancel' as EventName<
      IgcFileInputComponentEventMap['igcCancel']
    >,
  },
});

export type IgrFileInput = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrFileInputModule = Component;
